"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpClientImpl = void 0;
const axios_1 = __importDefault(require("axios"));
const types_1 = require("@refinitiv-data/types");
const lodash_functions_1 = require("../util/lodash-functions");
const config_1 = require("../config");
const logger_1 = require("../logger");
const request_params_serializer_1 = require("../util/request-params-serializer");
class HttpClientImpl {
    get defaultConfig() {
        return {
            paramsSerializer: request_params_serializer_1.commaRequestParamsSerializer,
            timeout: this.getTimeoutSetting(),
        };
    }
    get httpConfig() {
        return config_1.config.get('http');
    }
    static getInstance() {
        if (!this.instance) {
            this.instance = new this();
        }
        return this.instance;
    }
    constructor() {
        this.log = logger_1.logger.getLogger('http:client');
        this.log.debug('HTTP settings:', this.httpConfig);
    }
    request(config) {
        return axios_1.default.request(this.mergeDefaults(config));
    }
    post(url, data, config = {}) {
        return axios_1.default.post(url, data, this.mergeDefaults(config));
    }
    mergeDefaults(config) {
        return Object.assign(Object.assign({}, this.defaultConfig), config);
    }
    isValidTimeoutNumber(value) {
        return (0, lodash_functions_1.isNumber)(value) && Math.sign(value) >= 0 && Number.isFinite(value) && value <= Number.MAX_SAFE_INTEGER;
    }
    getTimeoutSetting() {
        let timeout = this.httpConfig['request-timeout'];
        timeout = (0, lodash_functions_1.isString)(timeout) ? Number(timeout) : timeout;
        if (!this.isValidTimeoutNumber(timeout)) {
            timeout = config_1.config.default(types_1.TIMEOUT_CONFIG_PATH);
            this.log.warn(`Invalid value of the "${types_1.TIMEOUT_CONFIG_PATH}". Default value "${timeout}" is used`);
        }
        return timeout * 1000;
    }
}
exports.HttpClientImpl = HttpClientImpl;
//# sourceMappingURL=data:application/json;base64,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